import { usePlotArea } from "../src/utils/usePlotArea";

export default usePlotArea